import React, { useEffect, useState } from "react";
import SchoolDetail from '../components/SchoolDetail';
import { useNavigate, useParams } from "react-router-dom";
import s from './school.module.css';

export default function School() {
	const navigate = useNavigate();
	let params = useParams();
  let schoolId = params.schoolId;
	
	const fetchData = async () => {
	}
	
	useEffect(() => {
		fetchData();
	}, []);
	
	return (<div style={{margin:"20px"}}>
		<SchoolDetail schoolId={schoolId} />
	</div>);
}